export default __webpack_public_path__ + "static/antigenKitContents_healgen-d47a33707d1d38176daacf94c28ba6c7.jpg";